import { Injectable } from '@angular/core';
import { ApiVersion } from '@core/constants';
import { BaseResponse } from '@core/models/base-response';
import { BaseService } from '@core/services/base.service';

@Injectable({
  providedIn: 'root',
})
export class ChangePasswordService extends BaseService {
  readonly changePasswordUrl = 'users/password/customer-user/update/current';

  sendChangePasswordRequest(
    currentPassword: string,
    newPassword: string,
    newPasswordRepeat: string
  ) {
    if (newPassword !== newPasswordRepeat) {
      throw new Error(`passwords are not matched`);
    }

    return this.put<BaseResponse<any>>(
      this.changePasswordUrl,
      {
        currentPassword,
        newPassword,
        newPasswordRepeat,
      },
      { apiVersion: ApiVersion.V2 }
    );
  }
}
